//#region Import
import React from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Typography,
} from '@mui/material';
import { SystemUpdateAlt } from '@mui/icons-material';
import { subscribeLiveUpdatePrompt } from '../../Services/Common/LiveUpdate';
//#endregion

/**
 * 긴급(IMMEDIATE) 웹 번들을 다 받았을 때 지금 적용할지 묻는 안내창
 * '나중에'를 누르면 다음에 앱을 새로 실행할 때 적용됨
 */
function LiveUpdateDialog() {
  const [prompt, setPrompt] = React.useState(null);
  const [dismissedVersion, setDismissedVersion] = React.useState('');
  const [applying, setApplying] = React.useState(false);

  React.useEffect(() => subscribeLiveUpdatePrompt(setPrompt), []);

  if (!prompt || prompt.version === dismissedVersion) return null;

  const HandleApply = async () => {
    setApplying(true);
    try {
      await prompt.apply(); // 성공하면 앱이 재시작되어 이후 코드는 실행되지 않음
    } catch (e) {
      console.warn('[LiveUpdate] 지금 적용 실패', e?.message || e);
      setApplying(false);
    }
  };

  return (
    <Dialog
      open={true}
      fullWidth
      maxWidth="xs"
      PaperProps={{ sx: { borderRadius: 3 } }}
    >
      <DialogTitle
        sx={{ display: 'flex', alignItems: 'center', gap: 1, fontWeight: 700 }}
      >
        <SystemUpdateAlt sx={{ color: '#2CA900' }} />
        업데이트 준비 완료
      </DialogTitle>
      <DialogContent>
        <Typography variant="body1" sx={{ mb: 1 }}>
          중요한 수정 사항이 반영된 업데이트가 준비되었습니다.
        </Typography>
        {prompt.releaseNote && (
          <Typography
            variant="body2"
            color="text.secondary"
            sx={{ mb: 1, whiteSpace: 'pre-line' }}
          >
            {prompt.releaseNote}
          </Typography>
        )}
        <Typography variant="body2" color="text.secondary">
          지금 적용하면 앱이 다시 시작됩니다. 작성 중인 내용이 있다면 먼저
          저장해 주세요.
        </Typography>
      </DialogContent>
      <DialogActions sx={{ px: 3, pb: 2 }}>
        <Button
          color="inherit"
          disabled={applying}
          onClick={() => setDismissedVersion(prompt.version)}
        >
          나중에
        </Button>
        <Button
          variant="contained"
          disableElevation
          disabled={applying}
          onClick={HandleApply}
        >
          지금 적용
        </Button>
      </DialogActions>
    </Dialog>
  );
}

export default LiveUpdateDialog;
